import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency) {
  if (amount === undefined || amount === null) return '0';
  const num = Number(amount);
  if (isNaN(num)) return '0';
  const decimals = ['BTC', 'ETH', 'BNB'].includes(currency) ? 8 : 2;
  if (currency === 'USDT') return `$${num.toFixed(decimals)}`;
  return `${num.toFixed(decimals)} ${currency}`;
}

export function formatUSD(amount) {
  if (!amount && amount !== 0) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

export function shortAddress(addr) {
  if (!addr) return '';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

export function timeAgo(dateStr) {
  const date = new Date(dateStr);
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString();
}

export const CURRENCY_ICONS = {
  BTC: { color: '#F7931A', name: 'Bitcoin', network: 'Bitcoin Network', logo: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png' },
  ETH: { color: '#627EEA', name: 'Ethereum', network: 'Ethereum (ERC-20)', logo: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png' },
  USDT: { color: '#26A17B', name: 'Tether', network: 'Tron (TRC-20)', logo: 'https://assets.coingecko.com/coins/images/325/small/Tether.png' },
  BNB: { color: '#F3BA2F', name: 'BNB', network: 'BNB Smart Chain (BEP-20)', logo: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png' },
  USD: { color: '#16A34A', name: 'Доллар США', flag: 'US' },
  EUR: { color: '#1D4ED8', name: 'Евро', flag: 'EU' },
  RUB: { color: '#4F46E5', name: 'Российский рубль', flag: 'RU' },
  KZT: { color: '#0EA5E9', name: 'Казахстанский тенге', flag: 'KZ' },
  UZS: { color: '#10B981', name: 'Узбекский сум', flag: 'UZ' },
  AZN: { color: '#E11D48', name: 'Азербайджанский манат', flag: 'AZ' },
  AMD: { color: '#DC2626', name: 'Армянский драм', flag: 'AM' },
  BYN: { color: '#059669', name: 'Белорусский рубль', flag: 'BY' },
  KGS: { color: '#D97706', name: 'Киргизский сом', flag: 'KG' },
  MDL: { color: '#7C3AED', name: 'Молдавский лей', flag: 'MD' },
  TJS: { color: '#0891B2', name: 'Таджикский сомони', flag: 'TJ' },
  TMT: { color: '#65A30D', name: 'Туркменский манат', flag: 'TM' },
  GEL: { color: '#BE185D', name: 'Грузинский лари', flag: 'GE' },
};

// Convert country code to flag emoji
export function countryFlag(code) {
  if (!code) return '';
  return String.fromCodePoint(...[...code.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
}
